import request from '@/utils/http'

const PREFIX = '/analyse/overall/v1'

const analyseOverall = {
  analyse(params, isqueue) {
    return request(
      `${PREFIX}${isqueue ? '/queue' : ''}`,
      'post',
      params
    )
  },
  pageUsers(params) {
    return request(
      `${PREFIX}/pageUsers?param=${encodeURIComponent(JSON.stringify(params))}`,
      'get'
    )
  }
}

export default analyseOverall
